export enum Profil {
  NONE = 'None',
  MANAGER = 'Manager',
  TECHNICIAN = 'Technician',
  SCOUT = 'Scout',
}
